// Short two-note chime via Web Audio (no sound file needed). Preference stored per browser.
const KEY = "notif_sound";
let ctx = null;

export const soundOn = () => localStorage.getItem(KEY) !== "off";
export const setSoundOn = (on) => localStorage.setItem(KEY, on ? "on" : "off");

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Browsers only allow audio after a user gesture — unlock on the first click/tap.
if (typeof window !== "undefined") {
  const unlock = () => { const c = getCtx(); if (c && c.state === "suspended") c.resume(); };
  window.addEventListener("pointerdown", unlock, { once: true });
  window.addEventListener("keydown", unlock, { once: true });
}

export const playChime = (force = false) => {
  if (!force && !soundOn()) return;
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume();
  const now = c.currentTime;
  [[880, 0], [1320, 0.12]].forEach(([freq, at]) => {
    const o = c.createOscillator(); const g = c.createGain();
    o.type = "sine"; o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, now + at);
    g.gain.exponentialRampToValueAtTime(0.18, now + at + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.35);
    o.connect(g).connect(c.destination);
    o.start(now + at); o.stop(now + at + 0.4);
  });
};

// Tracks notification ids across polls; returns the new unread ones (empty on the first poll).
export const makeArrivalDetector = () => {
  let seen = null;
  return (items) => {
    const fresh = seen === null ? [] : items.filter((n) => !n.read && !seen.has(n.id));
    seen = new Set(items.map((n) => n.id));
    return fresh;
  };
};
